export enum Status {
  unavailable,
  ready
}
